/** Props for {@link Button}. */
export interface ButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'style'> {
  readonly children: React.ReactNode;
  /** Visual emphasis. Defaults to `secondary`. */
  readonly variant?: 'primary' | 'secondary' | 'danger';
}

/**
 * A button.
 *
 * `type` defaults to `button`: the HTML default of `submit` causes accidental form submissions,
 * which is a bug every codebase writes at least once.
 *
 * @param props - Component props.
 * @returns The button element.
 */
export function Button({
  children,
  variant = 'secondary',
  type = 'button',
  ...rest
}: ButtonProps): React.JSX.Element {
  return (
    <button {...rest} type={type} className={`gm-button gm-button--${variant}`}>
      {children}
    </button>
  );
}
